// extracted by mini-css-extract-plugin
module.exports = {"CustomCheckbox":"CustomCheckbox_CustomCheckbox__2C7t4","Checkmark":"CustomCheckbox_Checkmark__3OLU7"};